<template>
  <div>
    <div class="page-title">
      <el-button @click="$router.back()" class="back-btn" icon="iconfont icon-fanhui-copy" size="small"></el-button>
      新建报表模板
    </div>
    <el-form class="creat-form"
      :model="addCustomForm"
      ref="addCustomFormRef"
      :rules="addCustomFormRules"
      label-width="180px">
      <el-form-item label="报表名称" prop="reportName">
        <el-input class="max-input" v-model="addCustomForm.reportName" placeholder="请输入报表名称" maxlength="40" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="报表数据源" prop="dataSourceIdList">
        <el-select v-model="addCustomForm.dataSourceIdList" multiple collapse-tags filterable clearable placeholder="请选择投放账户" class="max-select">
          <el-option
            v-for="item in reportOptions"
            :key="item.agentAccountId"
            :label="item.agentAccountName"
            :value="item.agentAccountId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关键字所在层级" prop="keywordExtractType">
        <el-radio-group v-model="addCustomForm.keywordExtractType" @change="getSelectColumnList">
          <el-radio :label="2">计划</el-radio>
          <el-radio :label="1">广告组</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="关键字所在命名位置" prop="keywordExtractIndex">
        <el-input class="max-input" v-model.number="addCustomForm.keywordExtractIndex" @blur="inputNumberBlur($event,'addCustomForm.keywordExtractIndex')" oninput="value=value.replace(/[^0-9]/g,'')" placeholder="请输入数字"></el-input>
      </el-form-item>
      <el-form-item label="细分维度">
        <el-button @click="breakdownClick('')" type="text">+自定义维度</el-button>
        <ul class="dimension-ul">
          <li v-for="(item,index) in breakdownUl" :key="index">
            <div>{{item.breakdownName}}</div>
            <div>
              <i @click="breakdownClick(index)" class="iconfont icon-edit"></i>
              <i @click="breakdownDelete(index)" class="el-icon-close"></i>
            </div>
          </li>
        </ul>
      </el-form-item>
      <el-form-item label="数据指标">
        <!-- 基础数据指标 -->
        <div class="tip"><span></span>基础数据指标
          <el-popover
            popper-class="popper-problem"
            placement="right"
            trigger="hover"
            content="excel表上传数据指标模板">
            <i class="iconfont icon-wenhao" slot="reference"></i>
          </el-popover>
        </div>
        <div style="padding-left:9px;">
          <el-button @click="customMetricsClick('')" type="text">+自定义指标</el-button>
          <ul class="dimension-ul">
            <li v-for="(item,index) in customMetricsUl" :key="index">
              <div>{{item.columnName}}</div>
              <div>
                <i @click="customMetricsClick(index)" class="iconfont icon-edit"></i>
                <i @click="customMetricsDelete(index)" class="el-icon-close"></i>
              </div>
            </li>
          </ul>
        </div>
        <!-- 计算数据指标 -->
        <div class="tip"><span></span>计算数据指标</div>
        <div style="padding-left:9px;">
          <el-button @click="calculateClick('')" type="text">+自定义指标</el-button>
          <ul class="dimension-ul">
            <li v-for="(item,index) in calculateUl" :key="index">
              <div>{{item.calculateName}}</div>
              <div>
                <i @click="calculateClick(index)" class="iconfont icon-edit"></i>
                <i @click="calculateDelete(index)" class="el-icon-close"></i>
              </div>
            </li>
          </ul>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button @click="$router.push({path:'/report/reporttool/customReport'})">取消</el-button>
        <el-button type="primary" @click="createReport">创建报表</el-button>
      </el-form-item>
    </el-form>
    <!-- 细分维度对话框 -->
    <el-dialog title="细分维度" :visible.sync="breakdownDialog" width="430px"
    :close-on-click-modal="false" class="dialog" :before-close="breakdownClose">
      <el-form ref="breakdownFormRef" :model="breakdownForm" :rules="breakdownRules">
        <el-form-item label="" prop="breakdownName">
          <el-input class="max-input" v-model="breakdownForm.breakdownName" placeholder="请输入维度名称" maxlength="10" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="" prop="location">
          <el-input class="max-input" v-model="breakdownForm.location" @blur="inputNumberBlur($event,'breakdownForm.location')" oninput="value=value.replace(/[^0-9]/g,'')" placeholder="维度所在命名位置" maxlength="10" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="breakdownSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 基础数据指标对话框 -->
    <el-dialog title="自定义指标" :visible.sync="customMetricsDialog" width="430px"
    :close-on-click-modal="false" class="dialog" :before-close="customMetricsClose">
      <el-form ref="customMetricsFormRef" :model="customMetricsForm" :rules="customMetricsRules">
        <el-form-item label="" prop="columnName">
          <el-input class="max-input" v-model="customMetricsForm.columnName" placeholder="请输入指标名称" maxlength="10" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="customMetricsSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 计算数据指标对话框 -->
    <el-dialog title="自定义指标" :visible.sync="calculateDialog" width="560px"
    :close-on-click-modal="false" class="dialog" :before-close="calculateClose" v-if="calculateDialog">
      <el-form ref="calculateFormRef" :model="calculateForm" label-width="100px" :inline="true">
        <el-form-item label="指标名称" prop="calculateName"
        :rules="{required: true, message: '不能为空', trigger: 'blur'}">
          <el-input class="max-input" v-model="calculateForm.calculateName" placeholder="请输入指标名称" maxlength="10" show-word-limit></el-input>
        </el-form-item>
        <div class="formula-box">
          <div class="formula-name">指标计算公式</div>
          <div class="formula-div">
            <el-form-item prop="formulaNum"
            :rules="{required: true, message: '不能为空', trigger: 'change'}">
              <el-select v-model="calculateForm.formulaNum" placeholder="请选择" class="min-select">
                <el-option
                  v-for="item in numOptions"
                  :key="item.columnField"
                  :label="item.columnName"
                  :value="item.columnField">
                </el-option>
              </el-select>
            </el-form-item>
            <div class="inline-div" v-for="(item,index) in calculateForm.addFormula" :key="index">
              <el-form-item :prop="'addFormula.' + index + '.symbol'"
              :rules="{required: true, message: '不能为空', trigger: 'change'}">
                <el-select v-model="item.symbol" placeholder="符号" class="min-select">
                  <el-option
                    v-for="item in symbolOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :prop="'addFormula.' + index + '.numCol'"
              :rules="{required: true, message: '不能为空', trigger: 'change'}">
                <el-select v-model="item.numCol" placeholder="请选择" class="min-select">
                  <el-option
                    v-for="item in numOptions"
                    :key="item.columnField"
                    :label="item.columnName"
                    :value="item.columnField">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <i v-show="showAdd" @click="addFormula" class="iconfont icon-tianjia-copy"></i>
          </div>
        </div>
        <el-form-item label="指标显示" prop="calculateRadio">
          <el-radio-group v-model="calculateForm.calculateRadio">
            <el-radio :label="1">数值</el-radio>
            <el-radio :label="2">百分比</el-radio>
          </el-radio-group>
        </el-form-item>
        <div>
          <el-form-item label=" ">
            <el-button type="primary" @click="calculateSubmit">确 定</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'addCustomReport',
  data () {
    return {
      // 表单数据
      addCustomForm: {
        reportName: '',
        dataSourceIdList: [],
        keywordExtractType: 2,
        keywordExtractIndex: '', // 关键字所在命名位置
        itemDimensionPattern: '', // 细分维度
        dataDimensionPattern: '', // 基础数据指标
        calculateDimensionPattern: '' // 计算数据指标
      },
      // 报表数据源
      reportOptions: [],
      // 添加定制表单验证规则
      addCustomFormRules: {
        reportName: [
          { required: true, message: '请输入报表名称', trigger: 'blur' },
          { max: 40, message: '报表名称的长度不超过40个字', trigger: 'blur' }
        ],
        dataSourceIdList: [
          { required: true, message: '请选择报表数据源', trigger: 'change' }
        ],
        keywordExtractIndex: [
          { required: true, message: '请输入关键字所在命名位置', trigger: 'blur' }
        ]
      },
      // 细分维度对话框
      breakdownDialog: false,
      breakdownForm: {
        breakdownName: '',
        location: '',
        id: ''
      },
      // 细分维度列表
      breakdownUl: [
      //   {
      //   breakdownName: '地域',
      //   location: 1,
      //   id: 0
      // }
      ],
      breakdownUlId: -1,
      breakdownRules: {
        breakdownName: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        location: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      },
      // 基础数据指标对话框
      customMetricsDialog: false,
      customMetricsForm: {
        columnName: '',
        columnField: '',
        id: ''
      },
      // 基础数据指标列表
      customMetricsUl: [
      //   {
      //   columnName: '预约',
      //   columnField: 1,
      //   id: 0
      // }
      ],
      customMetricsUlId: -1,
      customMetricsRules: {
        columnName: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      },
      // 计算数据指标对话框
      calculateDialog: false,
      calculateForm: {
        calculateName: '',
        calculateRadio: 1,
        formulaNum: '',
        addFormula: [{
          symbol: '',
          numCol: ''
        }],
        id: ''
      },
      // 计算数据指标列表
      calculateUl: [
      //   {
      //   calculateName: '有效率',
      //   calculateRadio: 1,
      //   formulaNum: '',
      //   addFormula: [{
      //     symbol: '',
      //     numCol: ''
      //   }],
      //   id: 0
      // }
      ],
      calculateUlId: -1,
      numOptions: [], // 指标计算公式下拉框
      columnList: [], // 指标计算公式下拉框自定义列，从接口中获取的list
      symbolOptions: [{ // 符号 add,subtract,multiply,divide
        value: 'add',
        label: '+'
      }, {
        value: 'subtract',
        label: '-'
      }, {
        value: 'multiply',
        label: '*'
      }, {
        value: 'divide',
        label: '÷'
      }],
      showAdd: true // 添加符号是否展示
    }
  },
  created () {
    this.getAccountList4Select() // 报表数据源下拉框
    this.getSelectColumnList() // 指标计算公式下拉框
  },
  methods: {
    cloneObjectFn (obj) { // 对象复制
      return JSON.parse(JSON.stringify(obj))
    },
    // 创建报表--提交
    createReport () {
      // 提交请求前，表单预验证
      this.$refs.addCustomFormRef.validate(valid => {
        if (valid) {
          // 细分维度
          this.addCustomForm.itemDimensionPattern = ''
          if (this.breakdownUl !== []) {
            this.breakdownUl.forEach(item => {
              this.addCustomForm.itemDimensionPattern += item.breakdownName + '-' + item.location + ','
            })
            this.addCustomForm.itemDimensionPattern = this.addCustomForm.itemDimensionPattern.substr(0, this.addCustomForm.itemDimensionPattern.length - 1)
          }
          // 基础数据指标
          this.addCustomForm.dataDimensionPattern = ''
          if (this.customMetricsUl !== []) {
            this.customMetricsUl.forEach(item => {
              this.addCustomForm.dataDimensionPattern += item.columnName + ','
            })
            this.addCustomForm.dataDimensionPattern = this.addCustomForm.dataDimensionPattern.substr(0, this.addCustomForm.dataDimensionPattern.length - 1)
          }
          // 计算数据指标
          this.addCustomForm.calculateDimensionPattern = ''
          if (this.calculateUl !== []) {
            this.calculateUl.forEach(item => {
              this.addCustomForm.calculateDimensionPattern += item.calculateName + '-' + item.calculateRadio + '-' + item.formulaNum
              item.addFormula.forEach(subitem => {
                this.addCustomForm.calculateDimensionPattern += '-' + subitem.symbol + '-' + subitem.numCol
              })
              this.addCustomForm.calculateDimensionPattern += ','
            })
            this.addCustomForm.calculateDimensionPattern = this.addCustomForm.calculateDimensionPattern.substr(0, this.addCustomForm.calculateDimensionPattern.length - 1)
          }
          this.$service.post('/api/customReport/addCustomTempalteContent', this.addCustomForm).then(res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '应用成功!'
              })
              this.$router.push({name: 'customReport'})
            }
          }).catch(Err => {})
        }
      })
    },
    // 监听 细分维度对话框的事件
    // 点击确认
    breakdownSubmit () {
      this.$refs.breakdownFormRef.validate(valid => {
        if (valid) {
          if (this.breakdownForm.id === this.breakdownUlId) { // 修改
            this.isBreakdownRepeat()
          } else {
            let isRepeat = 0
            this.breakdownUl.forEach(item => {
              if (item.breakdownName === this.breakdownForm.breakdownName) {
                this.$message({
                  type: 'error',
                  message: '名称不能重复!'
                })
              } else {
                isRepeat++
              }
            })
            // 如果名称没有重复新增一条
            if (isRepeat === this.breakdownUl.length) {
              this.breakdownForm.id = this.breakdownUl.length
              this.breakdownUl.push(this.cloneObjectFn(this.breakdownForm))
              this.breakdownDialog = false
            }
          }
        }
      })
    },
    // 修改数据，查看是否和其他的名称重复
    isBreakdownRepeat () {
      let isRepeat = 0
      this.breakdownUl.forEach((item, index) => {
        if (item.breakdownName === this.breakdownForm.breakdownName & index !== this.breakdownUlId) {
          this.$message({
            type: 'error',
            message: '名称不能重复!'
          })
        } else {
          isRepeat++
        }
      })
      // 如果名称没有重复可修改此条数据
      if (isRepeat === this.breakdownUl.length) {
        this.breakdownUl[this.breakdownUlId] = this.cloneObjectFn(this.breakdownForm)
        this.breakdownDialog = false
      }
    },
    // 打开细分维度对话框
    breakdownClick (idx) {
      this.breakdownDialog = true
      if (idx !== '') {
        this.breakdownForm = this.cloneObjectFn(this.breakdownUl[idx])
        this.breakdownUlId = idx
      } else {
        this.breakdownForm = {
          breakdownName: '',
          location: '',
          id: ''
        }
      }
    },
    // 关闭细分维度对话框
    breakdownClose () {
      this.$refs.breakdownFormRef.clearValidate()
      // if (this.breakdownForm.id === this.breakdownUlId) {
      //   this.$refs.breakdownFormRef.validate(valid => {
      //     if (valid) {
      //       this.isBreakdownRepeat()
      //     }
      //   })
      // } else {
      this.breakdownDialog = false
      // }
    },
    // 删除细分维度
    breakdownDelete (idx) {
      this.breakdownUl.splice(idx, 1)
    },
    // 删除基础数据指标
    customMetricsDelete (idx) {
      this.customMetricsUl.splice(idx, 1)
    },
    // 删除计算数据指标
    calculateDelete (idx) {
      this.calculateUl.splice(idx, 1)
    },
    // 监听 基础数据指标对话框的事件
    // 点击确认
    customMetricsSubmit () {
      this.$refs.customMetricsFormRef.validate(valid => {
        if (valid) {
          if (this.customMetricsForm.id === this.customMetricsUlId) { // 修改
            this.isCustomMetricsRepeat()
          } else { // 新增一条
            let isRepeat = 0
            this.customMetricsUl.forEach(item => {
              if (item.columnName === this.customMetricsForm.columnName) {
                this.$message({
                  type: 'error',
                  message: '名称不能重复!'
                })
              } else {
                isRepeat++
              }
            })
            // 如果名称没有重复新增一条
            if (isRepeat === this.customMetricsUl.length) {
              this.customMetricsForm.id = this.customMetricsUl.length
              this.customMetricsForm.columnField = this.customMetricsUl.length + 1
              this.customMetricsUl.push(this.cloneObjectFn(this.customMetricsForm))
              this.numOptions.push(this.customMetricsForm) // 重新拼接指标计算公式下拉框数据
              this.customMetricsDialog = false
            }
          }
        }
      })
    },
    // 修改数据，查看是否和其他的名称重复
    isCustomMetricsRepeat () {
      let isRepeat = 0
      this.customMetricsUl.forEach((item, index) => {
        if (item.columnName === this.customMetricsForm.columnName & index !== this.customMetricsUlId) {
          this.$message({
            type: 'error',
            message: '名称不能重复!'
          })
        } else {
          isRepeat++
        }
      })
      // 如果名称没有重复可修改此条数据
      if (isRepeat === this.customMetricsUl.length) {
        this.customMetricsUl[this.customMetricsUlId] = this.cloneObjectFn(this.customMetricsForm)
        this.getNumOptions()
        this.customMetricsDialog = false
      }
    },
    // 打开基础数据对话框
    customMetricsClick (idx) {
      this.customMetricsDialog = true
      if (idx !== '') { // 编辑
        this.customMetricsForm = this.cloneObjectFn(this.customMetricsUl[idx])
        this.customMetricsUlId = idx
      } else { // 新增
        this.customMetricsForm = {
          columnName: '',
          columnField: '',
          id: ''
        }
      }
    },
    // 关闭基础数据对话框
    customMetricsClose () {
      this.$refs.customMetricsFormRef.clearValidate()
      // if (this.customMetricsForm.id === this.customMetricsUlId) {
      //   this.$refs.customMetricsFormRef.validate(valid => {
      //     if (valid) {
      //       this.isCustomMetricsRepeat()
      //     }
      //   })
      // } else {
      this.customMetricsDialog = false
      // }
    },
    // 监听 计算数据指标对话框的关闭事件
    // 点击确认
    calculateSubmit () {
      this.$refs.calculateFormRef.validate(valid => {
        if (valid) {
          if (this.calculateForm.id === this.calculateUlId) {
            this.isCalculateRepeat()
          } else {
            let isRepeat = 0
            this.calculateUl.forEach(item => {
              if (item.calculateName === this.calculateForm.calculateName) {
                this.$message({
                  type: 'error',
                  message: '名称不能重复!'
                })
              } else {
                isRepeat++
              }
            })
            // 如果名称没有重复新增一条
            if (isRepeat === this.calculateUl.length) {
              this.calculateForm.id = this.calculateUl.length
              this.calculateUl.push(this.cloneObjectFn(this.calculateForm))
              this.calculateDialog = false
            }
          }
        }
      })
    },
    // 修改数据，查看是否和其他的名称重复
    isCalculateRepeat () {
      // 修改数据，查看是否和其他的名称重复
      let isRepeat = 0
      this.calculateUl.forEach((item, index) => {
        if (item.calculateName === this.calculateForm.calculateName & index !== this.calculateUlId) {
          this.$message({
            type: 'error',
            message: '名称不能重复!'
          })
        } else {
          isRepeat++
        }
      })
      // 如果名称没有重复可修改此条数据
      if (isRepeat === this.calculateUl.length) {
        this.calculateUl[this.calculateUlId] = this.cloneObjectFn(this.calculateForm)
        this.calculateDialog = false
      }
    },
    // 打开计算数据对话框
    calculateClick (idx) {
      this.calculateDialog = true
      // this.$refs.calculateFormRef.clearValidate()
      if (idx !== '') { // 编辑修改
        this.calculateForm = this.cloneObjectFn(this.calculateUl[idx])
        this.calculateUlId = idx
        if (this.calculateForm.addFormula.length >= 4) {
          this.showAdd = false
        } else {
          this.showAdd = true
        }
      } else { // 新建
        this.calculateForm = {
          calculateName: '',
          calculateRadio: 1,
          formulaNum: '',
          addFormula: [{
            symbol: '',
            numCol: ''
          }],
          id: ''
        }
        this.showAdd = true
      }
    },
    // 关闭计算数据对话框
    calculateClose () {
      this.$refs.calculateFormRef.clearValidate()
      // if (this.calculateForm.id === this.calculateUlId) {
      //   this.$refs.calculateFormRef.validate(valid => {
      //     if (valid) {
      //       this.isCalculateRepeat()
      //     }
      //   })
      // } else {
      this.calculateDialog = false
      // }
    },
    // 添加公式
    addFormula () {
      this.calculateForm.addFormula.push({
        symbol: '',
        numCol: ''
      })
      if (this.calculateForm.addFormula.length >= 4) {
        this.showAdd = false
      } else {
        this.showAdd = true
      }
    },
    // 指标计算公式下拉框自定义列，从接口中获取list
    getSelectColumnList () {
      // let params = {}
      // keywordExtractType:1广告组 2计划 , dataLevel:4广告组 5计划
      // if (this.addCustomForm.keywordExtractType === 1) {
      //   params = {
      //     'dataLevel': 4
      //   }
      // } else {
      //   params = {
      //     'dataLevel': 5
      //   }
      // }
      this.$service.post('/api/customReport/getSelectedColumnList').then(res => {
        if (res.code === 200) {
          // this.columnList = []
          this.columnList = res.result
          this.getNumOptions()
        }
      }).catch(Err => {})
    },
    // 指标计算公式下拉框拼接自定义列和页面用户新增的基础数据指标
    getNumOptions () {
      this.numOptions = []
      if (this.customMetricsUl !== []) {
        this.numOptions = [...this.columnList, ...this.customMetricsUl]
      }
    },
    // 数据源下拉框
    getAccountList4Select () {
      this.$service.post('/api/project/getAccountList4Select').then(res => {
        if (res.code === 200) {
          this.reportOptions = res.result
        }
      }).catch(Err => {})
    },
    inputNumberBlur (e, name) {
      switch (name) {
        case 'addCustomForm.keywordExtractIndex':
          this.addCustomForm.keywordExtractIndex = e.target.value
          break
        case 'breakdownForm.location':
          this.breakdownForm.location = e.target.value
          break
        default:
          console.log('none name')
          break
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import './../../../styles/common/public.less';
// 表单
.creat-form{
  .el-input.max-input{
    width: 50%;
    min-width: 640px;
  }
  .el-select.max-select{
    width: 50%;
    min-width: 640px;
  }
  .dimension-ul{
    display: flex;
    flex-wrap: wrap;
    width: 50%;
    min-width: 640px;
    >li{
      width: calc(100% / 3);
      min-width: 200px;
      border: 1px solid #DFDFDF;
      border-left: 0;
      margin-bottom: 10px;
      padding: 10px 14px;
      display: flex;
      justify-content: space-between;
      line-height: 20px;
      &:nth-child(3n+1){
        border-left: 1px solid #DFDFDF;
      }
      .icon-edit{
        color: @themeColor;
        cursor: pointer;
      }
      .el-icon-close{
        color: @themeColor;
        font-weight: bold;
        cursor: pointer;
      }
    }
  }
  .tip{
    position: relative;
    padding-left: 9px;
    &::before{
      content: '';
      display: block;
      width: 5px;
      height: 5px;
      .borderRadius(50%);
      background: @fontColor;
      position: absolute;
      top: calc(50% - 2px);
      left: 0;
    }
  }
  .icon-wenhao{
    position: relative;
    top: 3px;
    line-height: 20px;
    margin-left: 2px;
  }
}
.dialog{
  .el-input.max-input{
    width: 400px;
  }
  .el-select.min-select{
    width: 110px;
  }
  .icon-tianjia-copy{
    color: @themeColor;
    margin: 0 5px;
    line-height: 42px;
  }
  .formula-box{
    display: flex;
    .formula-name{
      line-height: 40px;
      width: 100px;
      text-align: right;
      padding-right: 12px;
    }
    .formula-div{
      flex: 1;
      .inline-div{
        display: inline;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/report/customReport/addCustomReport.vue